import type { IxmTriggerV1TriggerKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const TRIGGER_BASE_PATH = getResolvedPath('/clearing/operations/trigger');
export const TRIGGER_TECH_OPS_BASE_PATH = getResolvedPath('/tech-ops/trigger');

export const getTriggerPath: EntityPathBuilder<IxmTriggerV1TriggerKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return TRIGGER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.triggerId) {
        return undefined;
      }

      return getResolvedPath(`${TRIGGER_BASE_PATH}/$triggerId`, context.keys);
    }
  }
};

export const getTechOpsTriggerPath: EntityPathBuilder<IxmTriggerV1TriggerKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return TRIGGER_TECH_OPS_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.triggerId) {
        return undefined;
      }

      return getResolvedPath(`${TRIGGER_TECH_OPS_BASE_PATH}/$triggerId`, context.keys);
    }
  }
};

export function getTriggerDetailPath(triggerId: string | undefined) {
  if (!triggerId) {
    return undefined;
  }

  return getTriggerPath({ kind: 'detail', keys: { triggerId } });
}

export function getTechOpsTriggerDetailPath(triggerId: string | undefined) {
  if (!triggerId) {
    return undefined;
  }

  return getTechOpsTriggerPath({ kind: 'detail', keys: { triggerId } });
}
